import React from "react"
import { useParams } from "react-router-dom"
import { EDIT } from "../../include/constant"
import SlideForm from "../common/SlideForm"
import SuperAdminHeader from "./Header"

const SuperAdminEditSlide = () => {
    const { id } = useParams()

    return <SuperAdminHeader >
         <div className="fixed-top-bar"> 
        <SlideForm
            id={id}
            title="Edit Slide"
            type={EDIT}
        />
    </div>
    </SuperAdminHeader>
}

export default SuperAdminEditSlide